import React, { useState } from 'react';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';

import { Button } from 'ui';
import WrittenResponseRepeatableQuestion from '../WrittenResponseRepeatableQuestion';

const RepeatableWrittenQuestion = props => {
  const { data, setFinishedWriting, isDisabled, setIsTabDisabled } = props;
  const { questionId } = data;
  const [draft, setDraft] = useState('');

  const handleSubmit = e => {
    e.preventDefault();
    const mediaRequest = {
      question_id: questionId,
      answer: draft,
    };
    request
      .post(routes.LESSON_ATTEMPTS(props.data.lessonId), mediaRequest)
      .then(() => {
        setDraft('');
        setFinishedWriting(true);
        setIsTabDisabled(false);
      })
      .catch(error => {
        console.error(error);
        // TODO: Handle Server Error
      });
  };

  let contentComponent;
  switch (data.questionType) {
    case 'written_response': {
      contentComponent = (
        <WrittenResponseRepeatableQuestion
          {...props}
          draft={draft}
          setDraft={setDraft}
          isDisabled={isDisabled}
          setFinishedWriting={setFinishedWriting}
        />
      );
      break;
    }
    default:
      contentComponent = null;
  }

  return (
    <div className="pl-32 pr-32">
      {contentComponent}
      <div className="d-f mt-8 mb-16 jc-e">
        <Button
          type="button"
          customColor
          disabled={draft === ''}
          onClick={e => handleSubmit(e)}
          loading={false}
        >
          {t('practice.repeatability.save_draft')}
        </Button>
      </div>
    </div>
  );
};

export default RepeatableWrittenQuestion;
